import { render, staticRenderFns } from "./TheDistricts.vue?vue&type=template&id=56d5af08&"
import script from "./TheDistricts.vue?vue&type=script&lang=ts&"
export * from "./TheDistricts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports